import digitalPrinting from "./templates/digital-printing";
import maintenance from "./templates/maintenance";
import additionalOpportunity from "./templates/additional-opportunity";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Экологичная практичная сумка из 100% хлопка или льна размером 37*42 см. Легко сворачивается и занимает мало места. Длина ручек позволяет носить её как в руке, так и на плече. Поверхность идеально подходит для нанесения сложных цветовых изображений и фотографий. Краска наносится непосредственно на ткань. В результате мы получаем яркий и живой принт.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати и уход`,
    content: {
      printingInfo: `${digitalPrinting}${additionalOpportunity}${maintenance}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
